import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import useExhibition from './useExhibition';
import { fetchVisitors } from '../../redux/actions/VisitorsActions';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from '../../constants/Urls';
import useSearchEngine, { SEARCH_DATATYPE } from '../Search/SearchEngine';
import FilterParams from '../../utils/FilterParams';
import User from '../../models/User';

function useVisitors(searchText, pageIndex = DEFAULT_PAGE_INDEX, pageSize = DEFAULT_PAGE_SIZE, filters = []) {
    const dispatch = useDispatch();
    const [visitors, setVisitors] = useState([]);
    const [exhibition] = useExhibition();
    const [loading, setLoading] = useState(false);
    const [totalPages, setTotalPages] = useState(1);

    const visitorsReducer = useSelector(state => state.visitorsReducer);

    const [resultSet,searching,finishedSearch, totalPagesSearch, totalItemsCount] = useSearchEngine(searchText,SEARCH_DATATYPE.visitor);

    useEffect(() => {
        if (!exhibition) {
            return;
        }

        dispatch(fetchVisitors(exhibition.getId(), {
            pageIndex:pageIndex,
            pageSize:pageSize,
            filters:filters.concat() //[FilterParams.orderByAsc(User.orderByParams.lastName)]
        }));
        setLoading(true);
    }, [exhibition, pageIndex, pageSize, filters.length])

    useEffect(() => {
        if (visitorsReducer.isFetching || !visitorsReducer.visitors || visitorsReducer.error.isError()) {
            return;
        }
        setLoading(false);
        if (pageIndex === DEFAULT_PAGE_INDEX) {
            setVisitors(visitorsReducer.visitors);
            setTotalPages(visitorsReducer.totalPages);
        } else {
            setVisitors(visitors.concat(visitorsReducer.visitors));
        }
    }, [visitorsReducer.isFetching])

    return [visitors,loading,totalPages,resultSet,searching,finishedSearch]
}

export default useVisitors
